import React, { useContext, useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getElectionType,
  getStateByPollData,
} from "../../redux/actions/privateApiAction";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { useNavigate } from "react-router-dom";
import SelectPredictionComp from "../../components/PridictionComp/SelectPredictionComp";
import { toTitleCase } from "../../helpers/TitleCase";
import { getCopyPolster } from "../../redux/actions/pollingAction";

const ElectionTypeComp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    CopyBestPosterResponse,
  } = useSelector((state) => state?.pollWeb);
  console.log("🚀 ~ ElectionTypeComp ~ CopyBestPosterResponse:", CopyBestPosterResponse[0]?.id)
  const [renderStateSelect, setRenderStateSelect] = useState(false);
  // const [showNext, setShowNext] = useState(false);
  const { prediction, setPrediction } = useContext(PredictionContext);
  useEffect(() => {
    if (prediction.selectCountry?.id) {
      dispatch(getStateByPollData(prediction.selectCountry?.id));
      dispatch(getElectionType(prediction.selectCountry?.id));
    } else {
      navigate("/prediction");
    }
  }, []);

  const { getElectionTypeResponse, getStateByPollDataResponse } = useSelector(
    (state) => state?.privateReducer
  );
  const handleStateSelection = (id, name) => {
    // setShowNext(true);
    setPrediction((prevState) => ({
      ...prevState,
      showNext: true,
      electionTypeData: {
        ...prevState.electionTypeData,
        ...{ ["state"]: id, ["stateName"]: name },
      },
    }));
  };
  // console.log("prediction ", prediction);

  const handleTypeSelection = (type) => {
    const { value, id, level } = type;
    setPrediction((prevState) => ({
      ...prevState,
      electionTypeData: {
        ...prevState.electionTypeData,
        ...{ ["type"]: value, ["id"]: id },
      },
    }));
    if (level === "National") {
      // setShowNext(true);

      setPrediction((prevState) => ({
        ...prevState,
        showNext: true,
      }));
    } else {
      setRenderStateSelect(true);
    }
  };

  const handleSelectPrediction = async (predictionTitle, slug) => {
    setPrediction((prev) => ({
      ...prev,
      predictionTitle: predictionTitle,
    }));

    if (slug === "copy-averages") {
      try {
        const response = await dispatch(getCopyPolster(slug));
        const data = response?.data?.data; // ✅ your returned data is here
        console.log("🚀 ~ handleSelectPrediction ~ response:", data)

        const pollsterId = data?.[0]?.id;

        if (!pollsterId) {
          console.error("Pollster ID not found in response:", data);
          return;
        }

        // navigate(
        //   `/prediction/new/modifyPrediction/${prediction?.electionTypeData?.state}?select=${slug}&pollster=[${pollsterId}]`
        // );
        navigate(
          `/prediction/new/${prediction?.electionTypeData?.state}?select=${slug}&pollster=[${pollsterId}]&modify=modify-overall-prediction`
        );
      } catch (err) {
        console.error("Failed to load copy polster data:", err);
      }
    } else {
      if (predictionTitle === "copy best") {
        navigate(
          `/prediction/new/makeSelection/${prediction?.electionTypeData?.state}?select=${slug}`
        );
      } else {
        navigate(
          `/prediction/new/${prediction?.electionTypeData?.state}?select=${slug}`
        );
      }
    }
  };


  return (
    <div>
      <div className="flex flex-col gap-5 py-2 my-2 overflow-y-auto max-h-[calc(100vh-80px)] md:max-h-[calc(100vh-100px)]">
        {!prediction?.showNext ? (
          <div>
            <>
              {/* Election Type Selection */}
              <p className="my-5 text-[21px] font-semibold">
                Select Election Type
              </p>
              {/* Election Type Cards */}
              <div className="my-2 grid grid-cols-1 min-[380px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2">
                {getElectionTypeResponse?.data?.map((type, index) => (
                  <div
                    key={type?.id}
                    className={`m-auto min-[380px]:m-0 size-[160px] hover:bg-white bg-[#F7F8FA] hover:border-2 border-red-500 cursor-pointer rounded-xl flex justify-center items-center flex-col ${!type?.isActive && "hidden"
                      }`}
                    onClick={() => handleTypeSelection(type)}
                  >
                    <img src={type.image} alt={type.name} width={80} />
                    <p className="mt-5 text-[12px] font-semibold">
                      {type.name}
                    </p>
                  </div>
                ))}
              </div>
            </>
            {prediction.newPrediction &&
              prediction.selectCountry &&
              prediction.electionTypeData?.id &&
              prediction.electionTypeData?.id !== null && (
                <div className="my-5">
                  {/* Select State Dropdown */}
                  <FormControl className="w-[15rem]" variant="outlined">
                    <InputLabel id="select-State-label">
                      Select State
                    </InputLabel>
                    <Select
                      labelId="select-State-label"
                      id="selectState"
                      name="state"
                      label="Select State"
                      value={prediction.electionTypeData?.state || ""}
                      sx={{
                        borderRadius: "15px",
                      }}
                      onChange={(event) =>
                        handleStateSelection(event.target.value, event.target)
                      }
                    >
                      {getStateByPollDataResponse?.data?.map((state) => {
                        return (
                          <MenuItem value={state?.id} key={state?.id}>
                            {toTitleCase(state?.name)}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              )}
          </div>
        ) : (
          <SelectPredictionComp
            handleSelectPrediction={handleSelectPrediction}
          />
        )}
      </div>
    </div>
  );
};

export default ElectionTypeComp;
